function CustomZoomInControl(controlDiv, map) {
    // Set CSS for the control border
    var controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#FFFFFF";
    controlUI.style.border = "none";
    controlUI.style.borderRadius = "4px";
    controlUI.style.boxShadow = "0px 12px 24px rgba(7, 11, 26, 0.1);";
    controlUI.style.cursor = "pointer";
    controlUI.style.marginBottom = "15px";
    controlUI.style.marginRight = "15px";
    controlUI.style.width = "40px";
    controlUI.style.height = "40px";
    controlUI.style.color = "#FB9500";
    controlUI.style.textAlign = "center";
    controlUI.classList.add("zoom__control");
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior
    var controlText = document.createElement("div");
    controlText.style.fontFamily = "Roboto,Arial,sans-serif";
    controlText.style.fontSize = "28px";
    controlText.style.lineHeight = "40px";
    controlText.style.fontWeight = "400";
    controlText.style.paddingLeft = "5px";
    controlText.style.paddingRight = "5px";
    controlText.style.userSelect = "none";
    controlText.innerHTML = "+";
    controlUI.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUI, "click", function () {
        map.setZoom(map.getZoom() + 1);
    });
}

function CustomZoomOutControl(controlDiv, map) {
    // Set CSS for the control border
    var controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#FFFFFF";
    controlUI.style.border = "none";
    controlUI.style.borderRadius = "4px";
    controlUI.style.boxShadow = "0px 12px 24px rgba(7, 11, 26, 0.1);";
    controlUI.style.cursor = "pointer";
    controlUI.style.marginBottom = "15px";
    controlUI.style.marginRight = "15px";
    controlUI.style.width = "40px";
    controlUI.style.height = "40px";
    controlUI.style.color = "#FB9500";
    controlUI.style.textAlign = "center";
    controlUI.style.userSelect = "none";
    controlUI.classList.add("zoom__control");
    controlDiv.appendChild(controlUI);

    // Set CSS for the control interior
    var controlText = document.createElement("div");
    controlText.style.fontFamily = "Roboto,Arial,sans-serif";
    controlText.style.fontSize = "50px";
    controlText.style.lineHeight = "40px";
    controlText.style.fontWeight = "400";
    controlText.style.paddingLeft = "5px";
    controlText.style.paddingRight = "5px";
    controlText.innerHTML = "-";
    controlUI.appendChild(controlText);

    // Setup the click event listeners
    google.maps.event.addDomListener(controlUI, "click", function () {
        map.setZoom(map.getZoom() - 1);
    });
}

(function ($) {
    /*T his function will render a Google Map onto the selected jQuery element*/
    function closeLastOpenedMetroInfoWindow() {
        if (lastOpenedMetroInfoWindow) {
            lastOpenedMetroInfoWindow.close();
        }
    }

    function search_new_map($el) {
        var $markers = $el.find(".marker");
        var args = {
            zoom: 12,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: true,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
            },
            fullscreenControl: false,
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.RIGHT_CENTER,
            },
            streetViewControl: false,
            scaleControl: false,
            zoomControl: false,
        };

        // create map
        var map = new google.maps.Map($el[0], args);
        var customZoomInControlDiv = document.createElement("div");
        var customZoomInControl = new CustomZoomInControl(customZoomInControlDiv, map);

        customZoomInControlDiv.index = 1;
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(customZoomInControlDiv);

        var customZoomOutControlDiv = document.createElement("div");
        var customZoomOutControl = new CustomZoomOutControl(customZoomOutControlDiv, map);
        customZoomOutControlDiv.index = 1;
        map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(customZoomOutControlDiv);

        const position = new google.maps.LatLng(47.4863342, 19.0702858);

        map.setCenter(position);
        map.setZoom(12);

        map.setOptions({
            styles: [
                {
                    featureType: "administrative",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "administrative.province",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: 65,
                        },
                        {
                            visibility: "on",
                        },
                    ],
                },
                {
                    featureType: "landscape",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            hue: "#ff0000",
                        },
                        {
                            lightness: "-6",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            lightness: "50",
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100",
                        },
                    ],
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "road.arterial",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "30",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "40",
                        },
                    ],
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            hue: "#ffff00",
                        },
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -97,
                        },
                    ],
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [
                        {
                            lightness: -25,
                        },
                        {
                            saturation: -100,
                        },
                    ],
                },
                {
                    featureType: "transit.line",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "poi",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
            ],
        });

        // add a markers reference
        map.markers = [];
        // map.dummymarkers = [];
        map.markerLines = [];
        map.infowindow = [];
        map.newMetroLayers = [];

        // add markers
        $markers.each(function () {
            search_add_marker($(this), map);
        });

        var clusterStyles = [
            {
                textColor: "black",
                url: localize.themeurl + "/assets/img/svg/cluster.svg",
                height: 63,
                width: 106,
                extraText: localize.translations.projekt,
            },
        ];

        // MarkerClusterer
        var options = {
            styles: clusterStyles,
            clusterClass: "custom-cluster",
        };

        $.markerCluster = new MarkerClusterer(map, map.markers, options);

        map.layers = [];

        /* Load subway layere */
        var metro = new google.maps.Data({
            layer_id: "metro",
        });

        metro.loadGeoJson(`${localize.themeurl}/assets/js/extra/geojson/newmetro_onelineonly.json`);

        var lineSymbol = {
            path: "M 0,-1 0,1",
            strokeOpacity: 1,
            scale: 4,
            strokeWeight: 2,
        };

        google.maps.event.addListener(metro, "addfeature", function (e) {
            var feature = e.feature;
            var color = feature.getProperty("colour");
            var geometry = feature.getGeometry();
            var type = feature.getGeometry().getType();

            if (type === "LineString") {
                var newMetroLine = new google.maps.Polyline({
                    map: null,
                    path: geometry.getArray(),
                    strokeOpacity: 0,
                    fillOpacity: 0,
                    strokeColor: color,
                    strokeWeight: 2,
                    icons: [
                        {
                            icon: lineSymbol,
                            offset: "0",
                            repeat: "20px",
                        },
                    ],
                });
            }

            if (type === "Point") {
                var markerSymbol = feature.getProperty("marker-symbol");

                var icon = {
                    url: `${localize.themeurl}/assets/img/svg/metro/${markerSymbol}.svg`,
                    anchor: new google.maps.Point(12.5, 12.5),
                    scaledSize: new google.maps.Size(25, 25),
                };

                var newMetroLine = new google.maps.Marker({
                    position: geometry.get(),
                    map: null,
                    draggable: false,
                    icon: icon,
                });
            }

            var metrowindow = new google.maps.InfoWindow({
                pixelOffset: new google.maps.Size(160, 60),
            });

            var featureName = feature.getProperty("name");

            if ($.langCookie != "hu") {
                featureName = feature.getProperty("name_en");
            }

            newMetroLine.addListener("click", function (event) {
                metrowindow.setContent(
                    html`<div class="metroinfowindow" style="background-color:${color};">
            <i class="icon-x-circle control-icon close-metroinfowindow js-close-metroinfowindow"></i>
            <p>${featureName}</p>
          </div>`
                );
                var anchor = new google.maps.MVCObject();
                anchor.set("position", event.latLng);
                closeLastOpenedMetroInfoWindow();
                metrowindow.open(map, anchor);
                lastOpenedMetroInfoWindow = metrowindow;
                removeDefaultInfowindow();
            });

            $(document).on("click", ".js-close-metroinfowindow", function () {
                closeLastOpenedMetroInfoWindow();
            });

            map.newMetroLayers.push(newMetroLine);
        });

        // center map
        search_center_map(map);

        google.maps.event.addListenerOnce(map, "idle", function () {
            $.each(map.markers, function () {
                removeDefaultInfowindow();
            });
        });

        // return
        return map;
    }

    $.search_add_layers = function search_add_layers(layer_id, map) {
        var layer = new google.maps.Data({
            layer_id: layer_id,
        });


        layer.loadGeoJson(`${localize.themeurl}/assets/js/extra/geojson/${layer_id}.json`);

        layer.setStyle(function (feature) {
            var color = feature.getProperty("color");

            return {
                fillColor: color,
                fillOpacity: 0.17,
                strokeColor: color,
                strokeWeight: 3,
            };
        });

        map.layers.push(layer);
    };

    //Removing default infoWindow styles
    function removeDefaultInfowindow() {
        $(".gm-style-iw").next().css({ height: "0px" }); //remove arrow bottom inforwindow
        $(".gm-style-iw").next().css({ display: "none" });
        $(".gm-style-iw").prev().html(""); //remove style default inforwindows
        var p = $(".gm-style-iw").parent();
        p.css("height", "none");
        p.css("width", "none");
    }

    $(document).on("click", ".infowindow-wrapper", function (e) {
        e.preventDefault();

        const residentialId = $(this).data("residential");
        const checkbox = $("#residential-filter").find('input[data-residential*="' + residentialId + '"]');

        if (!checkbox.prop("checked")) {
            checkbox.prop("checked", true).change();
        }
    });

    function search_add_marker($marker, map) {
        if ($.freeflats[$marker.data("residential")] == undefined && $marker.data("hide") != "1") {
            return;
        }

        var latlng = new google.maps.LatLng($marker.attr("data-lat"), $marker.attr("data-lng"));

        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            optimized: false,
            anchorPoint: new google.maps.Point(0, 0),
            icon: {
                path: "M-7.5,0a7.5,7.5 0 1,0 15,0a7.5,7.5 0 1,0 -15,0",
                fillColor: "#fb9500",
                fillOpacity: 1,
                anchor: new google.maps.Point(0, 0),
                strokeWeight: 0,
                scale: 0,
            },
            residential: $marker.data("residential"),
            project: $marker.data("project"),
            url: $marker.data("url"),
            visible: false,
        });

        var infoWindowContent = $($marker.html());
        var lineColor = "#fb9500";
        if ($.freeflats[$marker.data("residential")] != undefined) {
            marker.solded = false;
        } else {
            if ($marker.data("hide") != "1") {
                marker.solded = true;
                $(infoWindowContent).addClass("solded");
                marker.icon.fillColor = "grey";
                lineColor = "grey";
            } else {
                marker.solded = "hide";
            }
        }

        google.maps.event.addListener(marker, "click", function () {
            window.location.href = this.url;
        });

        var markerLine = new google.maps.Polyline({});

        markerLine.setMap(map);

        // add to array
        map.markers.push(marker);
        // map.dummymarkers.push(dummymarker);
        map.markerLines.push(markerLine);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: infoWindowContent[0].outerHTML,
            });

            map.infowindow.push(infowindow);
            infowindow.open(map, marker);
            removeDefaultInfowindow();
        }
    }

    /* This function will center the map, showing all markers attached to this map */

    function search_center_map(map) {
        var bounds = new google.maps.LatLngBounds();
        var numofmarker = 0;

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            // var latlngDummy = new google.maps.LatLng(map.dummymarkers[i].position.lat(), map.dummymarkers[i].position.lng());

            if (marker.visible) {
                numofmarker++;
                bounds.extend(latlng);
                // bounds.extend(latlngDummy);
            }
        });

        /*If not enough markers add dummy points for better zoomin*/
        var minDistance = 0.002;
        var sumA = bounds.getNorthEast().lng() - bounds.getSouthWest().lng();
        var sumB = bounds.getNorthEast().lat() - bounds.getSouthWest().lat();

        if (sumA < minDistance && sumA > -minDistance && sumB < minDistance && sumB > -minDistance) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + minDistance, bounds.getNorthEast().lng() + minDistance);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - minDistance, bounds.getNorthEast().lng() - minDistance);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }

        if (numofmarker > 0) {
            // only 1 marker?
            if (map.markers.length == 1) {
                // set center of map

                map.setCenter(bounds.getCenter());

                /*           if ($.lakaskereso.filters.azonnal_koltozheto != undefined && $.lakaskereso.filters.azonnal_koltozheto == true) {
                              map.setZoom(13);
                          } else {
                              map.setZoom(12);
                          } */

            } else {
                /*        const position = new google.maps.LatLng(47.4863342, 19.0702858);
                       map.setCenter(position); */
                map.fitBounds(bounds);
                /*      if ($.lakaskereso.filters.azonnal_koltozheto != undefined && $.lakaskereso.filters.azonnal_koltozheto == true) {
                         map.setZoom(13);
                     } else {
                         map.setZoom(12);
                     } */
            }
        }
    }

    $.filterMapLayers = function filterMapLayers(districts) {
        if ($.searchMap != null) {
            for (var i = 0; i < $.searchMap.layers.length; i++) {
                var currentLayer = $.searchMap.layers[i];

                if ($.inArray(currentLayer.layer_id, districts) > -1 && districts) {
                    currentLayer.setMap($.searchMap);
                } else {
                    currentLayer.setMap(null);
                }
            }
        }
    };

    $.filterMarkers = function filterMarkers(residential, project) {
        if ($.searchMap != null) {
            var visiblePinCounter = 0;

            if ($.markerCluster != undefined) {
                $.markerCluster.clearMarkers();

                if ($.lakaskereso.filters.azonnal_koltozheto != undefined && $.lakaskereso.filters.azonnal_koltozheto == true) {
                    $.markerCluster.setMinimumClusterSize(999);
                } else {
                    $.markerCluster.setMinimumClusterSize(2);
                }
            }

            for (var i = 0; i < $.searchMap.markers.length; i++) {
                var markertohide = $.searchMap.markers[i];

                if ($.inArray(markertohide.residential.toString(), residential) > -1 && markertohide.project.some((p) => project.includes(p))) {
                    markertohide.setVisible(true);
                    if ($.markerCluster != undefined) {
                        $.markerCluster.addMarker(markertohide);
                    }
                    $.searchMap.markerLines[i].setMap($.searchMap);
                    $.searchMap.infowindow[i].open($.searchMap, markertohide);
                    removeDefaultInfowindow();
                    visiblePinCounter++;
                } else {
                    if ($("#solded").prop("checked")) {
                        if (markertohide.solded == false) {
                            markertohide.setVisible(false);
                            $.searchMap.infowindow[i].close();
                            $.searchMap.markerLines[i].setMap(null);
                            removeDefaultInfowindow();
                        }
                    } else {
                        markertohide.setVisible(false);
                        $.searchMap.infowindow[i].close();
                        $.searchMap.markerLines[i].setMap(null);
                        removeDefaultInfowindow();
                    }

                    if (markertohide.solded == "hide") {
                        markertohide.setVisible(true);
                        if ($.markerCluster != undefined) {
                            $.markerCluster.addMarker(markertohide);
                        }
                        $.searchMap.markerLines[i].setMap($.searchMap);
                        $.searchMap.infowindow[i].open($.searchMap, markertohideDummy);
                        removeDefaultInfowindow();
                        visiblePinCounter++;
                    }
                }
            }

            if (visiblePinCounter > 0) {
                search_center_map($.searchMap);
                pinAdjust();
                if ($.markerCluster != undefined) {
                    $.markerCluster.repaint();
                }
            }
        }

    };

    $.showSolded = function showSolded() {
        if ($.searchMap != null) {
            for (var i = 0; i < $.searchMap.markers.length; i++) {
                var markertoshow = $.searchMap.markers[i];

                if (markertoshow.solded == true) {
                    markertoshow.setVisible(true);
                    $.searchMap.markerLines[i].setMap($.searchMap);

                    removeDefaultInfowindow();
                }
            }
            search_center_map($.searchMap);
            pinAdjust();
        }
    };

    $.unshowSolded = function unshowSolded() {
        if ($.searchMap != null) {
            for (var i = 0; i < $.searchMap.markers.length; i++) {
                var markertoshow = $.searchMap.markers[i];
                if (markertoshow.solded == true) {
                    markertoshow.setVisible(false);
                    $.searchMap.markerLines[i].setMap(null);
                    $.searchMap.infowindow[i].close();
                }
            }
        }
    };

    var $mapOverlay = $(".js-map-detailed-filters");

    function pinAdjust() {
        if ($.searchMap != null) {
            if ($mapOverlay.hasClass("open")) {
                var $window = $(window);
                if ($window.width() >= 992) {
                    var overlayWidth = $mapOverlay.outerWidth();
                    $.searchMap.panBy(-overlayWidth, 0);
                }
            }
        }
    }

    /* This function will render each map when the document is ready (page has loaded)*/
    $.searchMap = null;
    $.freeflats = null;
    var lastOpenedMetroInfoWindow = null;

    $(function () {
        if ($(".t-map-search").length) {
            // Function to create map and handle API call
            function initializeMap() {
                cordiaAPI
                    .get("/sf/getfreeflats", {
                        params: {
                            lang: $.langCookie,
                        },
                    })
                    .then(function (response) {
                        $.freeflats = response.data.numbers;

                        $(".search-map").each(function () {
                            $.searchMap = search_new_map($(this));

                            if ($.searchMap) {
                                if ($(".t-map-search").length) {
                                    $(
                                        $.lakaskereso.fulldb.project
                                            .map((e) => e["kerulet"])
                                            .filter((e) => e)
                                            .filter($.onlyUnique)
                                            .map((e) => parseInt(e))
                                            .sort((a, b) => a - b)
                                    ).each(function (i, e) {
                                        if ($.searchMap != null) {
                                            $.search_add_layers(e, $.searchMap);
                                        }

                                    });
                                }
                            }
                        });
                    })
                    .catch(function (error) {

                        setTimeout(initializeMap, 500);
                    });

                $(".js-filters-header,.js-filters-footer,.js-map-detailed-filters,.js-map-found-list").toggleClass("open");

                if (window.location.hash === `#${localize.translations.detailedSearchSlug}`) {
                    // Do nothing if the hash matches
                } else {
                    setTimeout(function () {
                        $(".js-map-found-list").addClass("open");
                    }, 1500);
                }
            }

            // Call the function to initialize the map and handle API call
            initializeMap();
        }
    });

    /*Centering map when window is resized*/
    if ($(".search-map").length) {
        $(window).resize(function () {
            setTimeout(function () {
                if ($.searchMap != null) {
                    search_center_map($.searchMap);
                }
                pinAdjust();
            }, 100);
        });
    }

    $(".js-search-view-toggler").on("click", function () {
        if ($(this).hasClass("active")) {
            return false;
        }

        $(".js-search-view-toggler").each(function () {
            $(this).toggleClass("active");
        });

        const id = $(this).prop("id");

        if (id === "js-list-view") {
            $(".js-clone-to").addClass("col-xl-12 col-xxl-12 fullwidth");
            $(".t-map-search").hide();
            localStorage.setObj('listview', true);
        } else {
            $(".js-clone-to").removeClass("col-xl-12 col-xxl-12 fullwidth");
            $(".t-map-search").show();
            localStorage.setObj('listview', false);
        }
    });

})(jQuery);
